/** Where an admin who needs more seats should go (MKT-383). */
export const SUPPORT_EMAIL = 'support@medscout.io';

/** Prefilled so the request lands with context rather than an empty subject. */
export const SEAT_LIMIT_EMAIL_SUBJECT =
  'Request for additional MedScout licenses';

export const SEAT_LIMIT_COPY = {
  title: 'No licenses available',
  /** @param total - contracted seats */
  summary: (total: number) =>
    `All ${total} of your licenses are in use, so a new user cannot be added yet.`,
  /** Shown when the account has no contracted seat count recorded. */
  summaryNoLimit:
    'There are no licenses available, so a new user cannot be added yet.',
  optionsTitle: 'To make room for someone new:',
  deactivateOption:
    'Deactivate a user who no longer needs access — their license is freed immediately.',
  /** Spells the address out so it can be copied without using the button. */
  contactOption: `Or reach out to your customer success manager, or email ${SUPPORT_EMAIL}, to add more licenses.`,
  emailAction: 'Email support',
  closeAction: 'Close',
} as const;
